export const ListingApiEndpoint = process.env.VUE_APP_LISTING_API_ENDPOINT;
export const OrderApiEndpoint = process.env.VUE_APP_ORDER_API_ENDPOINT;
export const CustomerApiEndpoint = process.env.VUE_APP_CUSTOMER_API_ENDPOINT;
export const MessageApiEndpoint = process.env.VUE_APP_MESSAGE_API_ENDPOINT;
export const SuperTokensApiEndpoint = process.env.VUE_APP_SUPERTOKENS_API_ENDPOINT;
export const SuperTokensCookieDomain = process.env.VUE_APP_SUPERTOKENS_COOKIE_DOMAIN;

export const FilterDefaultPostalCode = '50001';
export const FilterLimitPrice = 40;
export const FilterLimitDistance = 1200;
export const FilterDefaultDistance = 1200;
export const DefaultStartWorkHour = '08:00';
export const DefaultEndWorkHour = '17:00';
export const DefaultWorkingDays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
export const OrdersPerPage = 10;

export const BeePalletComission = 0;
export const BeePalletComissionMessage = '** Por la campaña de lanzamiento.';
export const BeePalletGTagManagerId = 'GTM-MGRBD2KS';

//export const MADERA = "MADERA";
